import React from 'react';
import ImageResponsiveAssets from './ImageResponsiveAssets';

interface AckoDriveLogoProps {
  className?: string;
  variant?: "dark" | "light";
}

export const AckoDriveLogo: React.FC<AckoDriveLogoProps> = ({ className, variant }) => {
  const fillColor = variant === "dark";
  return (
    <div className={className}>
      <ImageResponsiveAssets
        name={`acko-drive-logo-${fillColor ? 'dark' : 'light'}`}
        alt='Acko Drive Logo'
        width={64}
        height={24}
        filePath={`/images/logos`}
      />
    </div>
  );
};

export default AckoDriveLogo; 